module.exports = __webpack_public_path__ + "img/make-friends-party_zh.769dd61a.png";